import { render, staticRenderFns } from "./pantalla7-1web.vue?vue&type=template&id=60d68df1&scoped=true&"
var script = {}
import style0 from "./pantalla7-1web.vue?vue&type=style&index=0&id=60d68df1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d68df1",
  null
  
)

export default component.exports